import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "container-fluid gdwrapper col-l-12 col-m-12 col-12" };
const _hoisted_2 = ["for"];
const _hoisted_3 = ["id", "aria-placeholder", "placeholder", "value"];
const _hoisted_4 = ["value"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'EnumInput',
    props: /*@__PURE__*/ _mergeModels({
        dataField: {},
        placeHolder: {},
        items: {}
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*@__PURE__*/ _mergeModels(['update:modelValue'], ["update:modelValue"]),
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emits = __emit;
        const modelValue = _useModel(__props, "modelValue");
        function updateValue(event) {
            emits('update:modelValue', event.target.value);
            // console.log(event.target.value);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("label", {
                    class: "col-l-3 col-m-4 col-5",
                    for: props.dataField
                }, _toDisplayString(props.dataField), 9, _hoisted_2),
                _createElementVNode("select", {
                    id: props.dataField,
                    class: "col-l-9 col-m-8 col-7",
                    "aria-placeholder": _ctx.placeHolder,
                    placeholder: _ctx.placeHolder,
                    value: modelValue.value,
                    onChange: updateValue
                }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (option, key) => {
                        return (_openBlock(), _createElementBlock("option", {
                            key: key,
                            value: key
                        }, _toDisplayString(option), 9, _hoisted_4));
                    }), 128))
                ], 40, _hoisted_3)
            ]));
        };
    }
});
